import React from "react";

import BusyOverlay from "components/Flow/BusyOverlay";
import useBusy from "hooks/useBusy";

function GlobalBusyOverlay() {
  const busy = useBusy();
  return <BusyOverlay message={busy?.message} note={busy?.note} />;
}

export default GlobalBusyOverlay;
